module.exports = __webpack_public_path__ + "static/img/BK4.b7cd313.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/BK4.png
// module id = 2FQf
// module chunks = 9